import { BRANDS } from "../../../configs";

const fromFieldAdapter = (data, brand = BRANDS.SWG) => {
	let apiData = data.Regions;
	if (brand?.toLowerCase() !== BRANDS.SWG.toLowerCase()) {
		apiData = data.gateways;
	}
	const dataSource = { ...data };

	if (apiData?.length > 0) {
		// Force Canada region, if available
		const canadaRegion = apiData.filter(region => region.Code === "CA");
		dataSource.Regions = canadaRegion || apiData[0];
	}

	let defaultGateway = {
		label: dataSource?.DefaultGateway?.Name,
		value: dataSource?.DefaultGateway?.Code,
	};

	let list = [];
	let listView = [];

	if (brand?.toLowerCase() === BRANDS.SOV.toLowerCase()) {
		list = [
			{
				title: "",
				items: dataSource?.gateways?.map(value => ({
					label: value?.name,
					value: value?.code,
				})),
			},
		];

		// sov data object does not include `Default Gateway` data value
		const _defaultGateway = dataSource?.gateways?.find(
			item => item?.name.toLowerCase() === "toronto"
		);

		defaultGateway = _defaultGateway
			? { label: _defaultGateway?.name, value: _defaultGateway?.code }
			: defaultGateway;
	} else {
		list = dataSource?.Regions[0]?.GatewayGroups?.map(group => ({
			title: group?.Code,
			items: group?.Gateways?.map(gateway => ({
				label: gateway?.Name,
				value: gateway?.Code,
			})),
		}));

		listView = {
			popularGateways: dataSource?.Regions[0]?.PopularGateways.sort((a, b) =>
				a.Name.localeCompare(b.Name)
			),
			gatewayGroups: dataSource?.Regions[0]?.GatewayGroups,
		};
	}

	return [defaultGateway, list, listView];
};

export default fromFieldAdapter;
